module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/tk-e3d850fb9644bf50d89118be561bd46e.svg";